import { useNavigate, useLocation } from 'react-router-dom';
import { useUser, ROLE_LABELS, ROLE_COLORS } from '../UserContext';

const NAV_ITEMS = [
  { path: '/',               label: 'Map',           roles: ['tech','field_engineer','rpm','design','management','admin','field_manager','director','managing_director'] },
  { path: '/my-work',        label: 'My Work',       roles: ['tech','field_engineer'] },
  { path: '/ops',            label: 'Ops',           roles: ['tech','field_engineer','rpm','management','admin','field_manager'] },
  { path: '/materials',      label: 'Materials',     roles: ['tech','field_engineer','rpm','management','admin','field_manager','director','managing_director'] },
  { path: '/field-manager',  label: 'Field Mgr',    roles: ['field_manager','admin'] },
  { path: '/dashboard',      label: 'Dashboard',     roles: ['management','rpm','admin','director','managing_director','field_manager'] },
  { path: '/design',         label: 'FMP Queue',     roles: ['field_engineer','design','admin'] },
  { path: '/team',           label: 'My Team',       roles: ['rpm','management','admin','director','managing_director','field_manager'] },
];

export default function NavBar({ onLogout }) {
  const user = useUser();
  const navigate = useNavigate();
  const location = useLocation();

  const visibleItems = NAV_ITEMS.filter(item =>
    !user || item.roles.includes(user.role)
  );

  return (
    <div style={{
      height: 48, backgroundColor: '#0f172a', borderBottom: '1px solid #1e293b',
      display: 'flex', alignItems: 'center', paddingLeft: 16, paddingRight: 16,
      gap: 4, fontFamily: 'sans-serif', flexShrink: 0, zIndex: 500,
      position: 'relative',
    }}>
      <div style={{ fontWeight: 'bold', fontSize: 15, color: '#3b82f6', marginRight: 12, letterSpacing: '0.02em' }}>
        FieldCore
      </div>

      {visibleItems.map(item => {
        const active = location.pathname === item.path ||
          (item.path !== '/' && location.pathname.startsWith(item.path));
        return (
          <button
            key={item.path}
            onClick={() => navigate(item.path)}
            style={{
              padding: '4px 12px', borderRadius: 6, border: 'none',
              backgroundColor: active ? '#1e3a5f' : 'transparent',
              color: active ? '#93c5fd' : '#94a3b8',
              cursor: 'pointer', fontSize: 13, fontWeight: active ? 'bold' : 'normal',
              transition: 'all 0.15s',
            }}
            onMouseEnter={e => { if (!active) e.currentTarget.style.backgroundColor = '#1e293b'; }}
            onMouseLeave={e => { if (!active) e.currentTarget.style.backgroundColor = 'transparent'; }}
          >
            {item.label}
          </button>
        );
      })}

      <div style={{ flex: 1 }} />

      {user && (
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ textAlign: 'right' }}>
            <div style={{ color: '#e2e8f0', fontSize: 13, fontWeight: 'bold' }}>{user.name}</div>
            <div style={{
              fontSize: 10, fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.06em',
              color: ROLE_COLORS[user.role] || '#64748b',
            }}>{ROLE_LABELS[user.role] || user.role}</div>
          </div>
          <button
            onClick={onLogout}
            style={{ padding: '4px 10px', backgroundColor: 'transparent', border: '1px solid #334155', color: '#64748b', borderRadius: 6, cursor: 'pointer', fontSize: 12 }}
          >Sign out</button>
        </div>
      )}
    </div>
  );
}
